module.exports = __webpack_public_path__ + "assets/help.svg?cedf16633d8e8a705b191539ec753a10";